import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Frame } from '../../components/shell/AppShell';
import PageHeader from '../../components/shell/PageHeader';
import OverviewStats from '../../components/admin/OverviewStats';
import adminArt from '../../assets/bg/founder-admin.webp';

/**
 * Founder Desk. Superadmin only -- the figures come from superadmin-only
 * statistics, and recent activity can reveal Sworn membership.
 */
const Desk = () => {
  const { user } = useAuth();
  return (
    <Frame user={user} background={adminArt} scrim={0.5} activeKey="desk">
      <div data-testid="founder-desk">
        <PageHeader title="Founder Desk" subtitle="Overview" />
        <div className="mx-auto max-w-3xl px-4 pb-6 pt-3">
          <OverviewStats />
        </div>
      </div>
    </Frame>
  );
};

export default Desk;
